<div [ngStyle]="{ display: canScroll ? 'block' : 'none' }">
  <span class="mobile-message">
    {{ "SCROLLBAR.SWIPE_TO_VIEW_MORE" | translate }}
  </span>

  <span class="desktop-message">
    {{ "SCROLLBAR.SCROLL_RIGHT_TO_VIEW_MORE" | translate }}
  </span>

  <div class="external-scrollbar" (scroll)="syncScroll()" #scrollbar>
    <div
      class="external-scrollbar__inner"
      [ngStyle]="{ width: scrollWidth + 'px' }"
    ></div>
  </div>
</div>
